import { Link } from 'react-router-dom';
import type { Workstream } from '../types/workstream';
import type { Task } from '../types/task';

interface WorkstreamBreadcrumbProps {
  workstreamID: string;
  workstream: Workstream | null;
  taskID?: string;
  task?: Task | null;
}

function getWorkstreamColor(ws: Workstream): { background: string; border: string } {
  if (ws.deleted) {
    return { background: '#f8d7da', border: '#dc3545' };
  }
  if (ws.paused) {
    return { background: '#fff3cd', border: '#ffc107' };
  }
  return { background: '#d4edda', border: '#28a745' };
}

function formatTaskLabel(task: Task, ws: Workstream): string {
  const num = task.TaskNumber;
  if (!num) {
    return task.TaskID;
  }
  if (ws.defaultShortName) {
    return `${ws.defaultShortName.toUpperCase()}-${num}`;
  }
  return String(num);
}

export default function WorkstreamBreadcrumb({ workstreamID, workstream, taskID, task }: WorkstreamBreadcrumbProps) {
  if (!workstream) {
    return null;
  }

  const colors = getWorkstreamColor(workstream);
  const showTask = !!taskID;
  const taskLabel = task && workstream ? formatTaskLabel(task, workstream) : taskID;

  return (
    <nav
      aria-label="Breadcrumb"
      style={{
        display: 'flex',
        alignItems: 'center',
        gap: '8px',
        fontSize: '14px',
      }}
    >
      <Link
        className="menu-item-link"
        to="/tasks/new"
      >
        Plan 42
      </Link>
      <span style={{ color: '#656d76' }} aria-hidden="true">&gt;</span>
      {showTask ? (
        <Link
          className="menu-item-link"
          to={`/workstreams/${encodeURIComponent(workstreamID)}`}
          style={{
            padding: '2px 10px',
            borderRadius: '6px',
            backgroundColor: colors.background,
            border: `1px solid ${colors.border}`,
            maxWidth: '250px',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
            display: 'inline-block',
          }}
        >
          {workstream.name}
        </Link>
      ) : (
        <span
          style={{
            padding: '2px 10px',
            borderRadius: '6px',
            backgroundColor: colors.background,
            border: `1px solid ${colors.border}`,
            maxWidth: '250px',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
            display: 'inline-block',
          }}
        >
          {workstream.name}
        </span>
      )}
      {showTask && (
        <>
          <span style={{ color: '#656d76' }} aria-hidden="true">&gt;</span>
          <span style={{ color: '#24292f', fontWeight: 500 }}>
            {taskLabel}
          </span>
        </>
      )}
    </nav>
  );
}
